__turbopack_context__.v({
  "link-text": "ReturnAppLink-module-scss-module__yLnY3W__link-text",
  "link-text-wrapper": "ReturnAppLink-module-scss-module__yLnY3W__link-text-wrapper",
});
